exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".competitor-search-actions{display:flex;justify-content:flex-end;margin-top:6px}.competitor-results-scroll{max-height:250px;overflow-y:auto;overflow-x:hidden}.competitor-search-actions>button.ca-search-search-btn{--mdc-protected-button-container-height:32px;min-height:32px!important;height:32px!important;padding:0 20px!important;border-radius:4px!important;font-weight:600!important;width:auto!important;min-width:160px!important;background-color:#0f3560!important;color:#fff!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./Client/app/views/competitors/add.competitors.component.css
// module id = 1195
// module chunks = 0